<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <!-- 字段编辑区 -->
        <div @mouseenter="mouseOverItem" @mouseleave="mouseOutItem" class="dataAreaItem" :style="{width: width + 'px'}">
            <div class="itemInner" :style="{width: noMenuWidth + 'px'}">
                <!-- 文本区 -->
                <el-popover v-model="fieldSelectVisible" trigger="manual" placement="left-start" width="300px">
                    <!-- 字段图标 + 名称 -->
                    <div slot="reference" class="dataAreaItem_text">
                        <div style="max-width: 75px" class="textOverflow">
                            <!-- 字段类型图标 -->
                            <svg-icon class="iconCommentClass"
                                      :style="{color: getColor(dataAreaItemData.fieldData)}"
                                      :icon-class="getFieldIcon(this.dataAreaItemData.fieldData)"></svg-icon>
                            <!-- BLA 选择区 -->
                            <my-menu style="margin-left: 2px;" v-model="BLAShow" trigger="hover"
                                     @click.stop="emptyClickHandler"
                                     :menu-list="BLAList"
                                     v-if="$comUtils.isNotEmpty(dataAreaItemData.BLA)"
                                     menu-width="35px"
                                     @menu-click="BLAChange">
                                <template v-slot:default>
                                    <div style="display: inline-block;" @mouseenter="BLAShow = true">
                                        <svg-icon class="iconCommentClass" :icon-class="getBLAIcon()"></svg-icon>
                                    </div>
                                </template>
                                <template v-slot:option="item">
                                    <div @click="BLAShow = false">
                                        <svg-icon class="iconCommentClass" :icon-class="item.item.icon"></svg-icon>
                                        {{item.item.displayText}}
                                    </div>
                                </template>
                            </my-menu>
                            <!-- 排序图标 -->
                            <svg-icon v-show="$comUtils.isNotEmpty(getOrder(dataAreaItemData))" class="iconCommentClass" :icon-class="getOrder(dataAreaItemData)"></svg-icon>
                        </div>
                        <div @click.stop="openFieldSelect" class="textOverflow"
                             style="cursor: pointer;padding-left: 5px; font-size: 12px;"
                             :style="{width: textWidth + 'px'}"
                             :title="dataAreaItemData.fieldNameRename">
                            <i class="el-icon-plus" v-if="!selected"></i>
                            {{selected ? dataAreaCommonUtils.getName(dataAreaItemData) : '请选择字段'}}
<!--                            {{(selected && $comUtils.isNotEmpty(dataAreaItemData.expression.displayText)) ? ('(' + dataAreaItemData.expression.displayText + ')') : ''}}-->
                        </div>
                    </div>
                    <!-- 字段选择区 -->
                    <div>
                        <!-- 字段筛选框 -->
                        <el-input v-model="fieldFilter" type="text" size="mini" suffix-icon="el-icon-search"
                                  placeholder="检索字段">
                        </el-input>
                        <!-- 字段展示区 -->
                        <div style="margin-top: 15px" v-for="(value, key) in fieldsGroup" :key="key">
                            <div v-if="$comUtils.isNotEmpty(value)">
                                <div>
                                    <el-divider content-position="left">{{key === 'D' ? '度量' : ('维度')}}</el-divider>
                                </div>
                                <el-row class="fieldSelectedGroup">
                                    <ul class="fieldList">
                                        <li v-for="item in value" :key="item.fieldName + item.disabled"
                                            :class="item.fieldName === dataAreaItemData.fieldNameOrigin ? 'selected' : ''">
                                            <el-button
                                                    :title="$comUtils.isEmpty(item.title) ? item.fieldName : item.title"
                                                    class="textOverflow"
                                                    :disabled="item.disabled || item.fieldName === dataAreaItemData.fieldNameOrigin"
                                                    type="text"
                                                    @click="fieldSelect(item)">
                                                <svg-icon class="iconCommentClass" :style="{color: getColor(item)}"
                                                          :icon-class="getFieldIcon(item)"></svg-icon>
                                                <span style="margin-left: 5px">{{item.fieldAlias}}</span>
                                            </el-button>
                                        </li>
                                    </ul>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </el-popover>
            </div>
            <!-- 菜单按钮 -->
            <div v-show="showMenu" class="itemInner" :style="{width: menuWidth + 'px'}">
                <my-menu :menu-list="computedMenuList" trigger="click" placement="bottom-end" :offset="38"
                         :show.sync="menuExpand" @menu-click="menuClickHandler_inner">
                    <el-button type="text" class="dataAreaItem_operation">
                        <i class="el-icon-setting"></i>
                    </el-button>
                </my-menu>
            </div>
            <!-- 删除按钮 -->
            <div :style="{width: menuWidth + 'px'}" class="itemInner" v-show="showMenu">
                <el-button type="text" class="dataAreaItem_operation" @click="deleteClickHandler">
                    <i class="el-icon-delete"></i>
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import MyMenu from "./MyMenu";
    import dataAreaCommonUtils from "../../utils/DataAreaCommonUtils"

    export default {
        name: "DataAreaItem",
        components: {MyMenu},
        props: {
            // 可选字段列表 结构{fieldName:'', fieldType: '', fieldTypeTrans: '', }
            fieldOptions: {
                type: Array,
                required: true,
            },
            // 回传/显的数据 .sync 进行双向绑定 ※ 注意要绑定原始数据而不是数据的引用
            // exp: (item, index) in array 应该绑定 array[index] 而不是 item，
            // item仅为array[index]的引用，直接给item赋值可能不会影响array[index]
            data: {
                type: Object,
            },
            // 序号
            xh: {
                type: Number,
                required: true
            },
            // 菜单项 格式见 MyMenu 组件 且 clickEventName 属性失效
            settingMenuList: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            // 菜单项过滤器 -1:不显示，0:显示但禁用，1:显示并启用
            menuChecker: {
                type: Function,
                default: () => {
                    return 1;
                }
            },
            // 校验器 弃用
            validator: {
                type: Function,
            },
            // 校验结果 .sync绑定 弃用
            validatedRes: {
                type: Boolean
            },
            // 组件宽度，单位px
            width: {
                type: Number,
                default: 260
            },
            // 添加新节点时的默认数据
            defaultItemData: {
                type: Function,
                required: true
            },
        },
        data: function () {
            return {
                dataAreaCommonUtils: dataAreaCommonUtils,
                // 唯一标志
                itemKey: this.$comUtils.getRandomNum(36),
                field: '',
                // 悬停状态
                hover: false,
                // 菜单状态
                menuExpand: false,
                // 重命名对话框状态 弃用
                renameDialog: false,
                // 自定义格式化对话框状态
                customFormatDialog: false,
                // 字段选择对话框状态
                fieldSelectVisible: false,
                // 字段筛选
                fieldFilter: '',
                // 当前组件验证状态
                pass: true,
                // 重命名数据 弃用
                renameFormData: {
                    renameText: '',
                },
                // BLA 状态
                BLAShow: false,
                // BLA 列表
                BLAList: [
                    {
                        displayText: '柱',
                        clickEventName: 'menu-click',
                        key: 'bar',
                        icon: 'bar-chart',
                        group: 'BLA'
                    }, {
                        displayText: '线',
                        clickEventName: 'menu-click',
                        key: 'line',
                        icon: 'line-chart',
                        group: 'BLA'
                    }, {
                        displayText: '面',
                        clickEventName: 'menu-click',
                        key: 'area',
                        icon: 'area-chart',
                        group: 'BLA'
                    },
                ],
                // 回传的数据
                dataAreaItemData: {
                    // 聚合形式
                    expression: {},
                    // 格式化
                    formatter: {},
                    // 字段原名
                    fieldNameOrigin: '',
                    // 字段重命名
                    fieldNameRename: '',
                    // 排序信息
                    order: {},
                    // bar or line or area chart
                    BLA: '',
                    // 原始字段信息
                    fieldData: {},
                    // 序号
                    xh: this.xh,
                }
            }
        },
        methods: {
            // 数据区鼠标悬停
            mouseOverItem: function (event) {
                event.stopPropagation();
                this.hover = true;
            },
            // 数据区鼠标移开
            mouseOutItem: function (event) {
                event.stopPropagation();
                this.hover = false;
            },
            // 菜单选项点击处理
            menuClickHandler_inner: function (menuData, parent) {
                // console.log(menuData, parent);
                this.$emit('menu-click', menuData, parent, this.xh, this.dataAreaItemData);
            },
            // 字段选择处理
            fieldSelect: function (item) {
                this.dataAreaItemData = this.defaultItemData(item);
                this.dataAreaItemData.fieldNameOrigin = item.fieldName;
                this.dataAreaItemData.fieldNameRename = '';
                // if (this.$comUtils.isEmpty(this.dataAreaItemData.expression.displayText)) {
                //     this.dataAreaItemData.fieldNameRename = item.fieldAlias;
                // } else {
                //     this.dataAreaItemData.fieldNameRename = item.fieldAlias + '(' + this.dataAreaItemData.expression.displayText + ')';
                // }
                this.dataAreaItemData.fieldData = item;
                this.fieldSelectVisible = false;
            },
            // 获取更新后的菜单
            getUpdateMenuList: function (data) {
                let array = jQuery.extend(true, [], this.settingMenuList);
                this.updateMenuList(array, data);
                return array;
            },
            //
            openFieldSelect: function () {
                let lastState = this.fieldSelectVisible;
                this.$root.$emit('clickBlank');
                this.$nextTick(() => {
                    this.fieldSelectVisible = !lastState;
                    if (this.fieldSelectVisible) {
                        this.$emit('item-select-dialog-open');
                    }
                });
            },
            // 根据数据更新菜单状态
            updateMenuList: function (array, data) {
                if (this.$comUtils.isEmpty(array)) {
                    return;
                }
                for (let i = 0; i < array.length; i++) {
                    let item = array[i];
                    let checker = this.menuChecker(item, this.dataAreaItemData);
                    if (checker >= 0) {
                        item.clickEventName = 'menu-click'
                        if (this.$comUtils.isNotEmpty(data[item.group]) &&
                            (data[item.group] === item.key || data[item.group].value === item.key || data[item.group].displayText === item.displayText)) {
                            item.selected = true;
                        } else {
                            item.selected = false;
                        }
                        if (this.$comUtils.isNotEmpty(item.children)) {
                            this.updateMenuList(item.children, data);
                        }
                        item.disabled = checker === 0;
                    } else {
                        item.visible = false;
                    }
                }
            },
            // 删除按钮点击处理
            deleteClickHandler: function () {
                this.$emit('remove-this', this.xh, this.dataAreaItemData);
            },
            // // 打开重命名 弃用
            // openRename: function () {
            //     this.renameDialog = true;
            //     this.renameFormData.renameText = this.dataAreaItemData.fieldNameRename;
            // },
            // // 提交重命名 弃用
            // commitRename: function () {
            //     this.renameDialog = false;
            //     this.dataAreaItemData.fieldNameRename = this.renameFormData.renameText;
            // },
            // 获取字段图标
            getFieldIcon: function (item) {
                return dataAreaCommonUtils.getFieldIcon(item)
            },
            /** 获取字体+图标颜色 */
            getColor: function (item) {
                return dataAreaCommonUtils.getColor(item)
            },
            // 获取柱线面图标
            getBLAIcon: function () {
                switch (this.dataAreaItemData.BLA.toLowerCase()) {
                    case 'area':
                        return 'area-chart';
                    case 'bar':
                        return 'bar-chart';
                    case 'line':
                        return 'line-chart';
                }
                return '';
            },
            // BLA 更新
            BLAChange: function (menuData, parent) {
                this.dataAreaItemData.BLA = menuData.key;
            },
            // 更新验证结果
            updateValidatedRes: function (val) {
                this.$emit('update:validatedRes', val);
            },
            // 获取排序的类型
            getOrder: function (item) {
                if (this.$comUtils.isNotEmpty(item.order) && item.order.value.toLowerCase() !== 'no') {
                    return item.order.value.toLowerCase();
                } else {
                    return '';
                }
            },
            emptyClickHandler: function () {

            },
        },
        watch: {
            // 监听回传数据变化，并回传
            dataAreaItemData: {
                handler: function (nv, ov) {
                    this.$emit('update:data', nv);
                    if (this.$comUtils.isNotEmpty(this.validator)) {
                        let validatorRes = this.validator(this.dataAreaItemData);
                        this.updateValidatedRes(validatorRes);
                    }
                    // 更新字段别名
                    let fieldOptions = this.fieldOptions;
                    let filter = fieldOptions.filter(val => {
                        return val.fieldName === nv.fieldData.fieldName;
                    });
                    if (filter.length > 0 && filter[0].fieldAlias !== nv.fieldData.fieldAlias) {
                        this.dataAreaItemData.fieldData.fieldAlias = filter[0].fieldAlias;
                    }
                    // console.log('数据更新',  nv);
                },
                deep: true
            },
            // 监听回显数据变化
            data: {
                handler: function (nv, ov) {
                    this.dataAreaItemData = nv;
                },
                deep: true
            },
            // 保证字段选择框单例
            fieldSelectVisible: function (nv, ov) {
                if (nv) {
                    this.$root.$emit('closeOther', this.itemKey);
                }
            },
            xh: function (nv, ov) {
                this.dataAreaItemData.xh = nv;
            }
        },
        computed: {
            // 是否已选择字段
            selected: function () {
                return !this.$comUtils.isEmpty(this.dataAreaItemData.fieldNameOrigin);
            },
            // 是否显示菜单按钮
            showMenu: function () {
                return (this.hover || this.menuExpand) && this.$comUtils.isNotEmpty(this.dataAreaItemData.fieldNameOrigin);
                // return true;
            },
            // 对字段进行分组
            fieldsGroup: function () {
                let assist = ['', 'W', 'D'];
                let obj = {
                    W: [],
                    D: [],
                }
                for (let i = 0; i < this.fieldOptions.length; i++) {
                    let item = this.fieldOptions[i];
                    if (this.$comUtils.isNotEmpty(this.fieldFilter)) {
                        if (item.fieldAlias.includes(this.fieldFilter)) {
                            obj[assist[parseInt(item.dataType)]].push(item);
                        }
                    } else {
                        obj[assist[parseInt(item.dataType)]].push(item);
                    }
                }
                return obj;
            },
            // 处理后的菜单项
            computedMenuList: function () {
                return this.getUpdateMenuList(this.dataAreaItemData);
            },
            // 文本区的宽度
            textWidth: function () {
                let iconW = 25;
                iconW += this.$comUtils.isNotEmpty(this.dataAreaItemData.BLA) ? 25 : 0;
                iconW += this.$comUtils.isNotEmpty(this.getOrder(this.dataAreaItemData)) ? 25 : 0;
                let divW = this.noMenuWidth;
                return (divW - iconW);
            },
            // 菜单区的宽度 (单个菜单)
            menuWidth: function () {
                let minW = 20;
                let actualW = this.width * 3 / 24;
                actualW = Math.min(minW, actualW);
                return actualW;
            },
            // 非菜单区宽度
            noMenuWidth: function () {
                return (this.width - (this.showMenu ? (2 * this.menuWidth) : 0));
            }
        },
        mounted() {
            if (this.$comUtils.isNotEmpty(this.data)) {
                this.dataAreaItemData = this.data;
            }

            this.$root.$on('closeOther', (key) => {
                if (this.itemKey !== key) {
                    // console.log(this.xh, this.fieldSelectVisible)
                    this.fieldSelectVisible = false;
                }
            });

            this.$root.$on('clickBlank', () => {
                this.fieldSelectVisible = false;
            });
        }
    }
</script>

<style scoped>
    .dataAreaItem_operation {
        text-align: center;
        line-height: 25px;
        font-size: 14px;
        padding: 0px 0px 0px 1px;
        color: black;
    }

    .iconCommentClass {
        font-size: 17px !important;
        line-height: 25px !important;
        width: 1em !important;
        height: 1em !important;
    }

    /* 列菜单样式 */
    .clickMenu {
        width: 180px;
        padding: 0px;
    }

    /* 列菜单选项样式 */
    .clickMenuItem {
        height: 25px;
        width: 100%;
        padding-top: 5px;
    }

    /* 列菜单选项按钮样式 */
    .clickMenuItem .el-button--text {
        font-size: 13px;
        text-align: left;
        color: black;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 15px;
        width: 100%;
        border-radius: 0px;
    }

    .itemInner {
        display: inline-block;
        height: 100%;
        overflow: hidden;
    }

    .clickMenuItem:first-of-type {
        border-top: none;
    }

    /* 列菜单悬停样式 */
    .clickMenuItem .el-button--text:hover {
        background-color: rgba(156, 156, 156, 0.42);
        background-repeat: space;
    }

    /* 选项选中样式 */
    .clickMenuItem_selected {
        color: #1c7cff !important;
    }

    .dataAreaItem {
        /* border: 1px solid black !important; */
        /* width: 160px; */
        height: 25px;
        /* zyfei增加style */
        border: 1px solid #c0c4cc !important;
        border-radius: 2px;
        width: 100%;
        /* zyfei增加style---end */
    }

    .textOverflow {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .dataAreaItem_text {
        width: 100%;
        height: 100%;
        font-size: 15px;
        line-height: 25px;
        /*border: 1px solid #3330 !important;*/
    }

    .dataAreaItem_text div {
        display: inline-block;
    }

    :v-deep .svg-icon {
        vertical-align: -0.21em;
    }

    ::v-deep .el-divider--horizontal {
        margin-bottom: 10px;
        margin-top: 10px;
    }

    ::v-deep .el-divider__text {
        /* font-size: 17px; */
        font-weight: bold;
        /* color: #e812a2; */

        /* zyfei增加style */
        font-size: 15px;
    }

    li {
        list-style-type: none !important;
    }

    ::v-deep li .el-input__inner {
        line-height: 23px;
        height: 23px;
    }

    ::v-deep li .el-input__icon {
        line-height: 23px;
    }

    .fieldList li .el-button {
        width: 100%;
        color: black;
        text-align: left;
        padding: 5px 5px;
        /* font-size: 15px; */
        max-width: 200px;
        /* font-weight: 600; */

        /* zyfei增加style */
        font-size: 13px;
    }

    .fieldList li .el-button--text:hover {
        background-color: rgba(156, 156, 156, 0.42);
    }

    .fieldList li .is-disabled:hover {
        background-color: unset !important;
    }

    .fieldList li .is-disabled {
        color: #9c9c9c !important;
    }

    .fieldList li.selected .el-button--text {
        color: #1a73e8 !important;
    }

    ::v-deep .el-popover__reference {
        outline-width: 0px !important;
    }
</style>
<style>
    .myPopover {
        min-width: unset;
        padding: 2px;
        box-shadow: 0 4px 5px rgba(0, 0, 0, 0.3), 0 0 4px rgba(0, 0, 0, 0.2);
        border-radius: 0px;
    }
    .fieldSelectedGroup {
        max-height: 300px;
        overflow-y: auto
    }
</style>
